import Core from "@/modules/core/service/Core";

const url = {
    upload: "/api/import/{0}/upload",
    import: "/api/import/{0}",
};

export default {
    type: {
        UNIT        : 10,
        LGS         : 11,
        CONTACT_UNIT: 220,
        CONTACT_VE  : 21,
        LIM         : 30,
        MNT         : 31,
        ESC         : 32,
        ZUS         : 33,
        OWNER_UNIT  : 40,
        OWNER_VE    : 41
    },

    upload (type, file, success, error) {
        console.log("upload")
        Core.transfer.uploadReturnsJson(url.upload.replace("{0}", type), file, success, error);
    },

    uploadImportFile (file, importerId, success, error) {
        console.log("upload")
        Core.transfer.uploadReturnsJson("/api/import/upload/{0}".replace("{0}", importerId), file, success, error);
    },

    import (customerId, data) {
        return Core.method.postVoid(url.import, data, customerId);
    },
}